import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

// design token 待调整....好像前面的规范定义不一致

const borderColor = '#E8ECF4'
const trHoverColor = '#FAFBFF'
const trChoosedColor = '#F2F7FF'
const highlightColor = '#FFF8E5'
const disabledColor = '#FBFBFB'

export const hideScrollBar = {
  '&::-webkit-scrollbar': {
    backgroundColor: 'transparent',
    height: 0,
    width: 0,
  },
}

export const tableRowStatusColors = {
  warning: '#FFF8E5',
  danger: '#FFF4F4',
  success: '#F0FCF6',
  lowlight: '#F7F7F7',
}

export default function initStyle() {
  return [
    registerThemeSpec('cmp.table', {
      empty: {
        border: `1px solid ${borderColor}`,
        borderTopWidth: 0,
        py: 26,
        textAlign: 'center',
        color: 'ash',
      },
      layout: {
        width: '100%',
        minWidth: '100%',
        margin: 0,
        padding: 0,
        tableLayout: 'fixed',
        borderCollapse: 'collapse',
      },
      noShadow: {
        boxShadow: 'none',
      },
      fixdLayoutBase: {
        position: 'absolute',
        top: 0,
        overflowX: 'hidden',
        overflowY: 'hidden',
        backgroundColor: 'white',
        zIndex: 2,
        borderCollapse: 'collapse',
      },
      fixedLeftLayout: {
        'cmp.table': 'fixdLayoutBase',
        left: 0,
        boxShadow: '2px 0px 6px #E4E6F2',
      },
      fixedRightLayout: {
        'cmp.table': 'fixdLayoutBase',
        right: 0,
        boxShadow: '-2px 0px 6px #E4E6F2',
      },
      bodyWrap: {
        overflowY: 'auto',
        height: 'auto',
      },
      base: {
        tr: {
          boxSizing: 'border-box',
          // borderBottom: `1px solid ${borderColor}`,
          transition: '.3s',
        },
        td: {
          boxSizing: 'border-box',
          fontSize: '14',
          lineHeight: '22px', // 有疑问
          textAlign: composeStyle.switch('align')
            .case('center', 'center')
            .case('left', 'left'),
          fontWeight: 'regular',
          border: composeStyle.switch('borderStyle')
            .case('full', `1px solid ${borderColor}`)
            .case('simple', `1px solid ${borderColor}`),
          borderLeft: composeStyle.switch('borderStyle')
            .case('simple', 'none'),
          borderRight: composeStyle.switch('borderStyle')
            .case('simple', 'none'),
          '&:nth-of-type(1)': {
            borderLeft: composeStyle.switch('borderStyle')
              .case('simple', `1px solid ${borderColor}`),
          },
          borderBottom: `1px solid ${borderColor}`,
          '&:nth-last-of-type(1)': {
            borderRight: composeStyle.switch('borderStyle')
              .case('simple', `1px solid ${borderColor}`),
          },
          padding: composeStyle.switch('size')
            .case('l', '24px')
            .case('m', '16px')
            .case('s', '12px'),
        },
      },
      thead: {
        tr: {
          'cmp.table.base': 'tr',
          color: 'body',
        },
        th: {
          'cmp.table.base': 'td',
          backgroundColor: 'palette.navy3.base',
          fontWeight: 'medium',
          padding: composeStyle.switch('size')
            .case('l', '16px 24px')
            .case('m', '16px')
            .case('s', '12px'),
          visibility: composeStyle.switch('hidden')
            .case(true, 'hidden')
            .case(false, 'inherit'),
        },
      },
      tbody: {
        tr: {
          'cmp.table.base': 'tr',
          color: 'body',
          backgroundColor: composeStyle.switch('customStatusColor')
            .case('disabled', disabledColor)
            .case('highlight', highlightColor),
          '&[status-selected="true"]': {
            backgroundColor: trChoosedColor,
          },
          '&[status-selected="true"] td': {
            backgroundColor: trChoosedColor,
          },
          '&:nth-of-type(even)': {
            backgroundColor: composeStyle.when('striped')
              .truthy('#F7F8FC'),
          },
          '&:hover td': {
            backgroundColor: trHoverColor,
          },
        },
        trMouseenterActive: {
          backgroundColor: trHoverColor,
        },
        td: {
          'cmp.table.base': 'td',
          borderTop: 'none',
          visibility: composeStyle.switch('hidden')
            .case(true, 'hidden')
            .case(false, 'inherit'),
        },
      },
      responsive: {
        table: {
          display: 'grid',
          gridGap: composeStyle.switch('borderStyle')
            .case('full', '1px'),
          'table, tbody, thead, tr, table ~ div': {
            display: 'contents',
          },
          'th, td': {
            display: 'flex',
            alignItems: 'center',
            border: composeStyle.switch('borderStyle')
              .case('full', 'none'),
            boxShadow: composeStyle.switch('borderStyle')
              .case('full', `0 0 0 1px ${borderColor}`),
          },
        },
      },
      checkboxWrap: {
        display: 'flex',
        width: '80px',
        justifyContent: 'center',
      },
      sort: {
        wrap: {
          display: 'inline-flex',
          flexDirection: 'column',
          alignItems: 'center',
          verticalAlign: 'middle',
          overflow: 'initial',
          marginLeft: '12px',
        },
        arrow: {
          width: 0,
          height: 0,
          border: '4px solid transparent',
          cursor: 'pointer',
        },
        arrowUp: {
          'cmp.table.sort': 'arrow',
          borderBottomColor: '#ccc',
          marginBottom: '2px',
          active: {
            borderBottomColor: '#2D2D2D',
          },
        },
        arrowDown: {
          'cmp.table.sort': 'arrow',
          borderTopColor: '#ccc',
          active: {
            borderTopColor: '#2D2D2D',
          },
        },
      },
    }),
  ]
}
